// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'RecommendationCardContext', value: value });
    } else {
			if (!('title' in value)) {
				errors.push({ path: 'value["title"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["title"] !== 'string') errors.push({ path: 'value["title"]', expected: 'string', value: value["title"] });
			}
			if (!('icon' in value)) {
				errors.push({ path: 'value["icon"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["icon"] !== 'string') errors.push({ path: 'value["icon"]', expected: 'string', value: value["icon"] });
			}
			if (!('body' in value)) {
				errors.push({ path: 'value["body"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["body"] !== 'string') errors.push({ path: 'value["body"]', expected: 'string', value: value["body"] });
			}
			if (!('ctas' in value)) {
				errors.push({ path: 'value["ctas"]', expected: 'RecommendationCardCta[]', value: undefined });
			} else {
				if (!Array.isArray(value["ctas"])) errors.push({ path: 'value["ctas"]', expected: 'array', value: value["ctas"] });if (Array.isArray(value["ctas"])) { value["ctas"].forEach((element, index) => { 
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        errors.push({ path: 'element', expected: 'RecommendationCardCta', value: element });
    } else {
			if (!('isPrimary' in element)) {
				errors.push({ path: 'element["isPrimary"]', expected: 'boolean | null', value: undefined });
			} else {
				
    {
        let element__isPrimary___valid = false;
        
        if (!element__isPrimary___valid) {
            const element__isPrimary___errors_0 = [];
            if (typeof element["isPrimary"] !== 'boolean') element__isPrimary___errors_0.push({ path: 'element["isPrimary"]', expected: 'boolean', value: element["isPrimary"] });
            if (element__isPrimary___errors_0.length === 0) {
                element__isPrimary___valid = true;
            }
        }

        if (!element__isPrimary___valid) {
            const element__isPrimary___errors_1 = [];
            if (element["isPrimary"] !== null) element__isPrimary___errors_1.push({ path: 'element["isPrimary"]', expected: 'null', value: element["isPrimary"] });
            if (element__isPrimary___errors_1.length === 0) {
                element__isPrimary___valid = true;
            }
        }
        if (!element__isPrimary___valid) {
            errors.push({ path: 'element["isPrimary"]', expected: 'boolean | null', value: element["isPrimary"] });
        }
    }
			}
			if (!('label' in element)) {
				errors.push({ path: 'element["label"]', expected: 'string', value: undefined });
			} else {
				if (typeof element["label"] !== 'string') errors.push({ path: 'element["label"]', expected: 'string', value: element["label"] });
			}
			if ('url' in element && element['url'] !== undefined) {
				
    {
        let element__url___valid = false;
        
        if (!element__url___valid) {
            const element__url___errors_0 = [];
            if (typeof element["url"] !== 'string') element__url___errors_0.push({ path: 'element["url"]', expected: 'string', value: element["url"] });
            if (element__url___errors_0.length === 0) {
                element__url___valid = true;
            }
        }

        if (!element__url___valid) {
            const element__url___errors_1 = [];
            if (element["url"] !== null) element__url___errors_1.push({ path: 'element["url"]', expected: 'null', value: element["url"] });
            if (element__url___errors_1.length === 0) {
                element__url___valid = true;
            }
        }
        if (!element__url___valid) {
            errors.push({ path: 'element["url"]', expected: 'string | null', value: element["url"] });
        }
    }
			}
			if ('actionType' in element && element['actionType'] !== undefined) {
				
    {
        let element__actionType___valid = false;
        
        if (!element__actionType___valid) {
            const element__actionType___errors_0 = [];
            
    {
        let element__actionType___valid = false;
        
        if (!element__actionType___valid) {
            const element__actionType___errors_0 = [];
            if (element["actionType"] !== "ROVO") element__actionType___errors_0.push({ path: 'element["actionType"]', expected: "ROVO", value: element["actionType"] });
            if (element__actionType___errors_0.length === 0) {
                element__actionType___valid = true;
            }
        }

        if (!element__actionType___valid) {
            const element__actionType___errors_1 = [];
            if (element["actionType"] !== "REDIRECT") element__actionType___errors_1.push({ path: 'element["actionType"]', expected: "REDIRECT", value: element["actionType"] });
            if (element__actionType___errors_1.length === 0) {
                element__actionType___valid = true;
            }
        }
        if (!element__actionType___valid) {
            element__actionType___errors_0.push({ path: 'element["actionType"]', expected: '"ROVO" | "REDIRECT"', value: element["actionType"] });
        }
    }
            if (element__actionType___errors_0.length === 0) {
                element__actionType___valid = true;
            }
        }

        if (!element__actionType___valid) {
            const element__actionType___errors_1 = [];
            if (element["actionType"] !== null) element__actionType___errors_1.push({ path: 'element["actionType"]', expected: 'null', value: element["actionType"] });
            if (element__actionType___errors_1.length === 0) {
                element__actionType___valid = true;
            }
        }
        if (!element__actionType___valid) {
            errors.push({ path: 'element["actionType"]', expected: '"ROVO" | "REDIRECT" | null', value: element["actionType"] });
        }
    }
			}
			if ('prompt' in element && element['prompt'] !== undefined) {
				
    {
        let element__prompt___valid = false;
        
        if (!element__prompt___valid) {
            const element__prompt___errors_0 = [];
            if (typeof element["prompt"] !== 'string') element__prompt___errors_0.push({ path: 'element["prompt"]', expected: 'string', value: element["prompt"] });
            if (element__prompt___errors_0.length === 0) {
                element__prompt___valid = true;
            }
        }

        if (!element__prompt___valid) {
            const element__prompt___errors_1 = [];
            if (element["prompt"] !== null) element__prompt___errors_1.push({ path: 'element["prompt"]', expected: 'null', value: element["prompt"] });
            if (element__prompt___errors_1.length === 0) {
                element__prompt___valid = true;
            }
        }
        if (!element__prompt___valid) {
            errors.push({ path: 'element["prompt"]', expected: 'string | null', value: element["prompt"] });
        }
    }
			}
    } }); }
			}
			if (!('recommendationId' in value)) {
				errors.push({ path: 'value["recommendationId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["recommendationId"] !== 'string') errors.push({ path: 'value["recommendationId"]', expected: 'string', value: value["recommendationId"] });
			}
			if ('avatars' in value && value['avatars'] !== undefined) {
				if (!Array.isArray(value["avatars"])) errors.push({ path: 'value["avatars"]', expected: 'array', value: value["avatars"] });if (Array.isArray(value["avatars"])) { value["avatars"].forEach((element, index) => { 
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        errors.push({ path: 'element', expected: 'object', value: element });
    } else {
			if (!('src' in element)) {
				errors.push({ path: 'element["src"]', expected: 'string', value: undefined });
			} else {
				if (typeof element["src"] !== 'string') errors.push({ path: 'element["src"]', expected: 'string', value: element["src"] });
			}
			if (!('name' in element)) {
				errors.push({ path: 'element["name"]', expected: 'string', value: undefined });
			} else {
				if (typeof element["name"] !== 'string') errors.push({ path: 'element["name"]', expected: 'string', value: element["name"] });
			}
    } }); }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
